import Vue from 'vue'
import router from '@/router'
import App from './App.vue'
import store from '@/store'
import common from '@/assets/js/common'

//Importing global styles
import "@/assets/css/style.css"
import "@/assets/css/ui.css";

//Importing Service Worker
// import './registerServiceWorker'
// Quill 
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

//Buefy
import Buefy from 'buefy'
import 'buefy/dist/buefy.min.css'
Vue.use(Buefy)

// Vue Select
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

// Vue Marquee
import VueMarqueeSlider from 'vue-marquee-slider';
Vue.use(VueMarqueeSlider)

// Vue Confetti
import VueConfetti from 'vue-confetti'
Vue.use(VueConfetti)

import VueDragResize from 'vue-drag-resize'
Vue.component('vue-drag-resize', VueDragResize)

import { ReactiveRefs } from 'vue-reactive-refs'
Vue.use(ReactiveRefs)

import VueResizeText from 'vue-resize-text';
Vue.use(VueResizeText)

// Vue Tree select
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
Vue.component('treeselect', Treeselect)

//Use Picture Library Select box component globally
import PictureLibrarySelect from '@/components/PictureLibrarySelect'
Vue.component('picture-library-select', PictureLibrarySelect)

// //Vue-Quill Editor
// import VueQuillEditor from 'vue-quill-editor'

// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme

// Vue.use(VueQuillEditor, /* { default global options } */)


Vue.config.productionTip = false
Vue.prototype.$common = common
const environment = 'P'
Vue.prototype.$environment = environment

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
